/* Design tokens: the dark theme (the only theme in v1) and the ONE source of tokens for the editor. Every ui-kit stylesheet
   and J's shell.css read these (shell.css imports this file); nothing hard-codes a colour or defines a parallel token set. */
:root {
  color-scheme: dark;

  --p2-bg: #1b1d21;
  --p2-bg-raised: #23262b;
  --p2-bg-input: #15171a;
  --p2-bg-hover: #2c3037;
  --p2-bg-active: #343943;
  --p2-border: #383d45;
  --p2-border-strong: #4b525d;

  --p2-fg: #e3e6ea;
  --p2-fg-muted: #9aa1ab;
  --p2-fg-disabled: #5f6670;

  --p2-accent: #3b82f6;
  --p2-accent-fg: #ffffff;
  --p2-accent-soft: rgba(59, 130, 246, 0.24);
  --p2-animate: #f59e0b;
  --p2-danger: #ef4444;
  --p2-focus-ring: #60a5fa;

  --p2-radius: 4px;
  --p2-space-1: 4px;
  --p2-space-2: 8px;
  --p2-space-3: 12px;
  --p2-control-h: 24px;
  --p2-font: system-ui, -apple-system, 'Segoe UI', 'Noto Sans Thai', sans-serif;
  --p2-font-mono: ui-monospace, 'Cascadia Mono', Consolas, monospace;
  --p2-font-size: 12px;

  --p2-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
  --p2-z-dialog: 1000;
  --p2-z-menu: 1100;

  /* Actor badge tones (Activity, presence pills, AI view); actorTone(name) picks one. */
  --p2-actor-0: #60a5fa;
  --p2-actor-1: #34d399;
  --p2-actor-2: #f472b6;
  --p2-actor-3: #fbbf24;
  --p2-actor-4: #a78bfa;
  --p2-actor-5: #f87171;
  --p2-actor-6: #2dd4bf;
  --p2-actor-7: #a3e635;
}
